<form [formGroup]="formGroupRef" *ngIf="config?.id" [ngStyle]="{'display' : show === false ? 'none' : 'flex'}">
  <div class="flex flex-row" style="display:inline-block">
    Follow up after
    <mat-form-field>
      <input matInput type="number" formControlName="{{config.id}}" min="0">
    </mat-form-field>
    days
  </div>
</form>
